// Tiny shared helpers. Intentionally minimal — no axios wrapper, no interceptors.
// Use alongside per-screen `axios` calls.

const configuredApiUrl = process.env.REACT_APP_API_URL;
const productionApiUrl = 'https://meta-invoice-app.uc.r.appspot.com';
const localHostnames = new Set(['localhost', '127.0.0.1', '::1']);
const browserHostname = typeof window === 'undefined' ? '' : window.location.hostname;
const runningLocally = localHostnames.has(browserHostname);

export const apiUrl = configuredApiUrl?.includes('localhost') && !runningLocally
  ? productionApiUrl
  : (configuredApiUrl || productionApiUrl);

/**
 * Trigger a browser download for an axios response with responseType: 'blob'.
 */
export function downloadBlob(response, filename) {
  const blob = response.data instanceof Blob
    ? response.data
    : new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Produce a short user-friendly error string for an axios error.
 */
export function handleApiError(err, fallback = 'Request failed') {
  if (!err) return fallback;
  if (err.response) {
    const status = err.response.status;
    const body = err.response.data;
    const msg = typeof body === 'string' ? body : body?.message || body?.error;
    return msg ? `${status}: ${msg}` : `${fallback} (HTTP ${status})`;
  }
  if (err.request) return `${fallback} (no response from server)`;
  return err.message || fallback;
}
